module.exports = __webpack_public_path__ + "img/font2.5235228c.png";